import { useTranslation } from 'react-i18next';
import { Status } from 'src/components/atoms/status';
import { EmployeeInvitationStatus } from 'src/features/employees/types/enum/employee-invitation-status';
import {
  invitationStateColor,
  invitationStateTranslations,
} from '../../constants/employee-invitation-status';

interface Props {
  invitationState: EmployeeInvitationStatus;
}

const EmployeeInvitationState = ({ invitationState }: Props) => {
  const { t } = useTranslation();

  return (
    <Status
      label={t(invitationStateTranslations[invitationState])}
      color={invitationStateColor[invitationState]}
    />
  );
};

export default EmployeeInvitationState;
